.productOption {
	display: flex;
	justify-content: space-between;
}
